module.exports = __webpack_public_path__ + "static/media/15.6abaa2a8.gif";